'use client';

import React from 'react';
import type { ChangeEvent } from 'react';
import { DateInput } from '@/design-system/components/Form/DateInput';
import { dateToDdMmYyyy, parseDdMmYyyyToDate } from '@/utils/helpers';

export interface DatePickerFieldProps {
  label: string;
  id?: string;
  name: string;

  /** Current value in DD.MM.YYYY (e.g. from react-hook-form watch) – syncs display with form state */
  value?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  ref?: React.RefCallback<HTMLInputElement | null>;
  error?: string;
  required?: boolean;
}

export const DatePickerField = ({
  id,
  label,
  name,
  value,
  onChange,
  onBlur,
  ref,
  error,
  required,
}: DatePickerFieldProps) => {
  const handleChange = (date: Date | null) => {
    const valueStr = date != null ? dateToDdMmYyyy(date) : '';
    onChange?.({ target: { name, value: valueStr } } as ChangeEvent<HTMLInputElement>);
  };

  return (
    <DateInput
      ref={ref}
      id={id ?? name}
      label={label}
      value={value ? (parseDdMmYyyyToDate(value) ?? null) : undefined}
      onChange={handleChange}
      onBlur={onBlur ?? undefined}
      error={error}
      required={required}
    />
  );
};

DatePickerField.displayName = 'DatePickerField';
